import React, { useState } from 'react';
import { ConsultingType } from 'types/course.type';
import fa from 'locales/fa.json';
import { ConsultingQuestionsRoute } from 'services/routes';
import QuestionCard from 'components/Consulting/questionCard';
import Link from 'next/link';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { SAllLink } from 'components/landing/style';
import { Modal } from 'antd';
import SendQuestion from 'components/Consulting/sendQuestion';
import { useSelector } from 'react-redux';

const Questions: React.FC<{ data: ConsultingType }> = ({ data }) => {
  const [openModal, setOpenModal] = useState(false);
  const user = useSelector((state) => state.account.user);

  return (
    <div className="w-[330px] md:w-[640px] m-auto xl:w-[1160px] mt-[40px] flex flex-col">
      <div className="text-indigo90 font-bold text-[22px] mb-[20px]">
        {fa.term.register.questions}{' '}
      </div>
      <div className="mb-[28px] text-center text-[13px] md:text-right text-black40">
        {data.publicQuestionDescription}
      </div>

      <div className="w-full">
        {data.questions.slice(0, 3).map((item) => (
          <QuestionCard key={item.answer} question={item} />
        ))}
      </div>

      <div className="flex justify-between text-[16px] text-blue-1 mt-[20px] items-center">
        {user ? (
          <div className="cursor-pointer" onClick={(): void => setOpenModal(true)}>
            ارسال پرسش
          </div>
        ) : (
          <div />
        )}
        <Link href={ConsultingQuestionsRoute()}>
          <SAllLink className="self-end cursor-pointer ">
            مشاهده همه سوالات <ArrowLeftOutlined />
          </SAllLink>
        </Link>
      </div>

      <Modal
        title={null}
        footer={null}
        destroyOnClose
        open={openModal}
        onCancel={(): void => setOpenModal(false)}
      >
        <SendQuestion skills={data.skills} />
      </Modal>
    </div>
  );
};

export default Questions;
